(() => {
    const FILTER_TRANSITION_DELAY = 450;
    const FILTER_PANEL_LABEL = 'Filtrar produtos';
    const overlayQuery = window.matchMedia('(max-width: 1024px)');
    let filterTrigger = null;
    let focusTimer = null;
    let pendingOpen = false;

    const getPanel = () => document.getElementById('halo-sidebar');
    const getTrigger = () => filterTrigger || document.querySelector('button.toolbar-item.toolbar-sidebar[data-sidebar][aria-controls="halo-sidebar"]');
    const isOpen = () => document.body.classList.contains('open-mobile-sidebar');

    const syncTriggerState = () => {
        const trigger = getTrigger();
        if (!trigger) return;

        if (overlayQuery.matches) {
            trigger.setAttribute('aria-expanded', String(isOpen()));
        } else {
            trigger.removeAttribute('aria-expanded');
        }
    };

    const syncPanelState = () => {
        const panel = getPanel();
        if (!panel) return;

        if (overlayQuery.matches) {
            panel.setAttribute('role', 'dialog');
            panel.setAttribute('aria-modal', 'true');
            panel.setAttribute('aria-label', FILTER_PANEL_LABEL);
            panel.toggleAttribute('inert', !isOpen());
        } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-modal');
            panel.removeAttribute('aria-label');
            panel.removeAttribute('inert');
        }
    };

    const openFilter = (trigger) => {
        if (!overlayQuery.matches) return;

        const panel = getPanel();
        if (!panel) return;

        filterTrigger = trigger;
        pendingOpen = true;
        panel.removeAttribute('inert');
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', FILTER_PANEL_LABEL);
        window.clearTimeout(focusTimer);
        focusTimer = window.setTimeout(() => {
            if (!isOpen()) {
                pendingOpen = false;
                panel.setAttribute('inert', '');
                return;
            }

            const hiddenFocusables = Array.from(panel.querySelectorAll(
                "a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type=hidden]):enabled, select:enabled, textarea:enabled"
            )).filter((element) => element.getClientRects().length === 0);
            const previousStates = hiddenFocusables.map((element) => ({
                element,
                disabled: 'disabled' in element ? element.disabled : null,
                href: element.getAttribute('href'),
                tabindex: element.getAttribute('tabindex')
            }));

            hiddenFocusables.forEach((element) => {
                if ('disabled' in element) element.disabled = true;
                if (element.matches('a[href]')) element.removeAttribute('href');
                if (element.hasAttribute('tabindex')) element.setAttribute('tabindex', '-1');
            });
            trapFocus(panel, panel.querySelector('.halo-sidebar-close'));
            previousStates.forEach(({ element, disabled, href, tabindex }) => {
                if (disabled !== null) element.disabled = disabled;
                if (href !== null) element.setAttribute('href', href);
                if (tabindex !== null) element.setAttribute('tabindex', tabindex);
            });
        }, FILTER_TRANSITION_DELAY);
    };

    const closeFilter = () => {
        pendingOpen = false;
        const panel = getPanel();
        const trigger = getTrigger();

        window.clearTimeout(focusTimer);
        document.body.classList.remove('open-mobile-sidebar');
        removeTrapFocus(trigger);
        panel?.setAttribute('inert', '');
    };

    const initialize = () => {
        if (!getPanel() || !getTrigger()) return;

        syncPanelState();
        syncTriggerState();

        const syncOnBodyClass = () => {
            syncTriggerState();
            const panel = getPanel();
            if (!panel || !overlayQuery.matches) return;

            if (isOpen()) {
                panel.removeAttribute('inert');
                pendingOpen = false;
            } else if (!pendingOpen) {
                panel.setAttribute('inert', '');
            }
        };
        const bodyClassObserver = new MutationObserver(syncOnBodyClass);
        bodyClassObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });

        document.addEventListener('click', (event) => {
            const trigger = event.target.closest?.('button.toolbar-item.toolbar-sidebar[data-sidebar][aria-controls="halo-sidebar"]');

            if (trigger) {
                openFilter(trigger);
                return;
            }

            if (!overlayQuery.matches || !isOpen()) return;

            if (event.target.closest?.('#halo-sidebar .halo-sidebar-close, .background-overlay')) {
                event.preventDefault();
                closeFilter();
            }
        }, true);

        document.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !overlayQuery.matches || !isOpen()) return;

            event.preventDefault();
            event.stopPropagation();
            closeFilter();
        }, true);

        overlayQuery.addEventListener('change', () => {
            pendingOpen = false;
            if (!overlayQuery.matches && isOpen()) closeFilter();
            syncPanelState();
            syncTriggerState();
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
})();
